import { render, staticRenderFns } from "./studioList.vue?vue&type=template&id=93f077f8&scoped=true"
import script from "./studioList.vue?vue&type=script&lang=js"
export * from "./studioList.vue?vue&type=script&lang=js"
import style0 from "./studioList.vue?vue&type=style&index=0&id=93f077f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f077f8",
  null
  
)

export default component.exports